import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { ARTICLE_COLLECTION } from '../queries/articleCollection.query';

export const getNewHomesArticleCollection = async (
    apolloClient: ApolloClient<NormalizedCacheObject>
) => {
    try {
        const { data } = await apolloClient.query({
            query: ARTICLE_COLLECTION,
            variables: {
                title: 'Buying a new-build home'
            }
        });

        const { articleCollection } = data;
        const { errorCode } = articleCollection;

        if (errorCode) {
            return null;
        }

        return articleCollection;
    } catch (error) {
        return null;
    }
};
